import { log, supabase } from ".";
import { capturarSnapshotDesdeVenta } from "./comisionSnapshot";

export const saveOportunidad = async (oportunidad) => {
  try {
    // Guardrail (regla 10.7, defensa en profundidad): jamás persistir una venta sin cliente
    // vinculado por ID. Si algún path futuro no resuelve client_id, la venta NO se guarda rota.
    if (!oportunidad?.client_id || isNaN(parseInt(oportunidad.client_id, 10))) {
      throw new Error("No se puede guardar una venta sin cliente vinculado (client_id).");
    }
    // insertReturning: trae la fila creada (con id) de forma atómica, sin re-query
    const data = await supabase.insertReturning("sales", oportunidad);

    if (!data || data.length === 0) throw new Error("Empty response");

    // Snapshot de comisión: ADITIVO — si falla, la venta se crea igual (solo se loguea)
    try {
      await capturarSnapshotDesdeVenta(data[0], "creacion");
    } catch (snapErr) {
      log.error("saveOportunidad/snapshot", snapErr);
    }

    return data;
  } catch (error) {
    log.error("saveOportunidad", error);
    throw error;
  }
};
